import { render, staticRenderFns } from "./AbbreviatedValue.vue?vue&type=template&id=0dce28fa&"
import script from "./AbbreviatedValue.vue?vue&type=script&lang=ts&"
export * from "./AbbreviatedValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports